import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './utils/rem.js'; //vue自适应配置文件
import './utils/css/base.css'//页面样式初始化
// 引入请求方式
import request from './utils/request'
Vue.prototype.$api = request
// 引入animate.css动态库
import 'animate.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
